import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.7809 2.6247C12.1259 2.19344 12.056 1.56415 11.6247 1.21914C11.1934 0.874128 10.5641 0.944049 10.2191 1.37531L2.21913 11.3753C1.92696 11.7405 1.92696 12.2595 2.21913 12.6247L10.2191 22.6247C10.5641 23.056 11.1934 23.1259 11.6247 22.7809C12.056 22.4359 12.1259 21.8066 11.7809 21.3753L4.28063 12L11.7809 2.6247Z M19.7809 2.6247C20.1259 2.19344 20.056 1.56415 19.6247 1.21914C19.1934 0.874128 18.5641 0.944049 18.2191 1.37531L10.2191 11.3753C9.92696 11.7405 9.92696 12.2595 10.2191 12.6247L18.2191 22.6247C18.5641 23.056 19.1934 23.1259 19.6247 22.7809C20.056 22.4359 20.1259 21.8066 19.7809 21.3753L12.2806 12L19.7809 2.6247Z"
  }));
});
var NavigationChevronDoubleLeft = AbstractIcon.withComponent(Icon);
NavigationChevronDoubleLeft.displayName = 'NavigationChevronDoubleLeft';
export default NavigationChevronDoubleLeft;